import { HStack, Icon, Spinner, Text, Center } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';

const CompanyScanApiStatus: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const apiStatus = useFlowsSelector((state) => state.flows.metaData.apiStatus);

  switch (apiStatus) {
    case 'ERROR':
      return (
        <SingleStatus
          Icon={<Icon name="GeneralActionsCloseOrRemove" color="danger.main" />}
          tooltipText={t('COMPANY-SCAN_BOTTOM-BAR_UNSAVED-PROGRESS-INFO')}
        >
          {t('UNSAVED_PROGRESS')}
        </SingleStatus>
      );
    case 'LOADING':
      return (
        <SingleStatus
          Icon={<Spinner color="gray.200" size="md" thickness="1px" />}
        >
          {t('SAVING_PROGRESS')}
        </SingleStatus>
      );
    case 'SUCCESS':
      return (
        <SingleStatus
          data-test-id="COMPANY-SCAN_BOTTOM-BAR_PROGRESS_SUCCESS"
          Icon={
            <Icon name="GeneralStatusSuccessCheckmark" color="success.main" />
          }
        >
          {t('PROGRESS_SAVED')}
        </SingleStatus>
      );
    default:
      return null;
  }
};

interface Props {
  tooltipText?: string;
  Icon: React.ReactElement;
  'data-test-id'?: string;
}

const SingleStatus: React.FC<React.PropsWithChildren<Props>> = ({
  Icon,
  children,
  'data-test-id': dataTestId,
}) => {
  return (
    <HStack
      data-test-id={dataTestId}
      spacing="2"
      transition="0.3s"
      justify="center"
    >
      <Center w="6" h="6">
        {Icon}
      </Center>
      <Text textStyle="smallBody" color="text.gray" minW="40">
        {children}
      </Text>
    </HStack>
  );
};

export default CompanyScanApiStatus;
